import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Crown } from 'lucide-react';
export function LaunchBanner() {
  return <motion.div initial={{
    y: -100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    type: 'spring',
    stiffness: 100,
    damping: 20
  }} className="bg-gradient-to-r from-brand-navy via-brand-navy/95 to-brand-navy text-white py-2 px-4 sticky top-0 z-50 shadow-xl border-b border-brand-yellow/20" data-id="element-425">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-center flex-wrap" data-id="element-426">
        <motion.div animate={{
        rotate: [0, -10, 10, -10, 0],
        scale: [1, 1.1, 1, 1.1, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        repeatDelay: 3
      }} data-id="element-427">
          <Crown className="w-4 h-4 text-brand-yellow" data-id="element-428" />
        </motion.div>

        <div className="flex items-center gap-2" data-id="element-429">
          <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 bg-brand-yellow/20 rounded-full text-xs font-bold tracking-wider border border-brand-yellow/30" data-id="element-430">
            <Sparkles className="w-3 h-3" data-id="element-431" />
            EDICIÓN PREMIUM
          </span>

          <span className="font-light text-sm text-brand-cream/90" data-id="element-432">
            Plan Anti-Pantallas Express
          </span>
        </div>

        <motion.div animate={{
        rotate: [0, 10, -10, 10, 0],
        scale: [1, 1.1, 1, 1.1, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        repeatDelay: 3,
        delay: 1
      }} data-id="element-433">
          <Crown className="w-4 h-4 text-brand-yellow" data-id="element-434" />
        </motion.div>
      </div>
    </motion.div>;
}